import React, { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Header from "../layout/Header";
import { connect, useDispatch } from "react-redux";
import { getApplication } from "../../actions/application/getApplication";

function ApplicationDetail(props) {
  const { Id, From } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getApplication(Id));
  }, [dispatch]);

  console.log(props);
  
  return (
    <div>
      <Header />
      <div className="pt-10 md:ml-64 ps-5">
        <ol
          className="flex items-center whitespace-nowrap min-w-0"
          aria-label="Breadcrumb"
        >
          <li className="text-sm">
            <Link
              to="/applications"
              className="flex items-center text-gray-500 hover:text-[#09C35C]"
              href="#"
            >
              Başvurularım
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </Link>
          </li>
          <li
            className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
            aria-current="page"
          >
            Başvuru Detayı
          </li>
        </ol>
      </div>
      <hr className="divide-y mt-2" />
      {props.getApplication.done ? (
        <div className="md:ml-64 ps-10 pe-5 mt-10">
          <div
            className="border-b border-gray-200 dark:border-gray-700"
            style={{ paddingTop: "45px" }}
          >
            <nav className="flex space-x-2" aria-label="Tabs" role="tablist">
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C] active"
                id="tabs-with-badges-item-4"
                data-hs-tab="#tabs-with-badges-1"
                aria-controls="tabs-with-badges-1"
                role="tab"
              >
                Başvuru Sonucu
              </button>
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C] active"
                id="tabs-with-badges-item-1"
                data-hs-tab="#tabs-with-badges-1"
                aria-controls="tabs-with-badges-1"
                role="tab"
              >
                Hasta Bilgileri
              </button>
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C]"
                id="tabs-with-badges-item-2"
                data-hs-tab="#tabs-with-badges-2"
                aria-controls="tabs-with-badges-2"
                role="tab"
              >
                Talep Formu
              </button>
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C]"
                id="tabs-with-badges-item-3"
                data-hs-tab="#tabs-with-badges-3"
                aria-controls="tabs-with-badges-3"
                role="tab"
              >
                Dosyalar{" "}
                <span className="hs-tab-active:bg-blue-100 hs-tab-active:text-[#09C35C] dark:hs-tab-active:bg-blue-800 dark:hs-tab-active:text-white ml-1 py-0.5 px-1.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300">
                  {props.getApplication.getApplication.attachments.length}
                </span>
              </button>
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C]"
                id="tabs-with-badges-item-4"
                data-hs-tab="#tabs-with-badges-4"
                aria-controls="tabs-with-badges-4"
                role="tab"
              >
                Hasta Raporu
              </button>
            </nav>
          </div>
          <div className="mt-3 text-start">
            <div
              id="tabs-with-badges-1"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-1"
            >
              <div className="mt-5">
                <p className="text-gray-500 dark:text-gray-400">Adı Soyadı</p>
                <p>
                  {props.getApplication.getApplication.applicationOwnerUser
                    .name +
                    " " +
                    props.getApplication.getApplication.applicationOwnerUser
                      .lastName}
                </p>
              </div>
              <div className="mt-3">
                <p className="text-gray-500 dark:text-gray-400">
                  Telefon Numarası
                </p>
                <p>
                  {" "}
                  {
                    props.getApplication.getApplication.applicationOwnerUser
                      .phoneNumber
                  }
                </p>
              </div>
              <div className="mt-3">
                <p className="text-gray-500 dark:text-gray-400">Mail Adresi</p>
                <p>
                  {
                    props.getApplication.getApplication.applicationOwnerUser
                      .email
                  }
                </p>
              </div>
            </div>
            <div
              id="tabs-with-badges-2"
              className="hidden"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-2"
            >
              <div className="flex justify-end mb-3">
                <Link
                  to={`/edit-triage/${props.getApplication.getApplication.id}`}
                  type="button"
                  className="py-2 px-3 inline-flex justify-center items-end gap-2 rounded-md bg-gray-100 border border-transparent font-semibold text-gray-500 hover:text-white hover:bg-gray-500 focus:outline-none focus:ring-2 ring-offset-white focus:ring-gray-500 focus:ring-offset-2 transition-all text-sm dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-600 dark:text-white dark:focus:ring-offset-gray-800"
                >
                  Düzenle
                </Link>
              </div>
              <div className="flex flex-col border rounded-md p-4 ">
                <div className="-m-1.5 overflow-x-auto">
                  <div className="p-1.5 min-w-full inline-block align-middle">
                    <div className="overflow-hidden">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead>
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                            >
                              Başvuru Sorusu
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                            >
                              Cevabınız
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                          {Object.entries(
                            JSON.parse(
                              props.getApplication.getApplication.survey.data
                            )
                          ).map(([key, value]) => {
                            return (
                              <tr key={key}>
                                <td>{key}</td>

                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">
                                  {typeof value === "object" ? (
                                    Object.entries(value).map(([k, v]) => (
                                      <div key={k}>
                                        {k}:{" "}
                                        {typeof v === "object"
                                          ? Object.entries(v).map(
                                              ([ke, va]) => (
                                                <div key={ke}>
                                                  <b>{ke}</b> <p>{va}</p>
                                                </div>
                                              )
                                            )
                                          : v}
                                      </div>
                                    ))
                                  ) : (
                                    <div>{value}</div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="tabs-with-badges-3"
              className="hidden"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-3"
            >
              {props.getApplication.done ? (
                <div className="flex">
                  <div className="list-group mt-3 mb-3 w-2/3">
                    {props.getApplication.getApplication.attachments.map(
                      (element, index) => {
                        return (
                          <>
                            <div
                              key={index}
                              className="flex mt-3 flex-col bg-white border shadow-sm rounded-xl p-4 md:p-5 dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7] dark:text-gray-400"
                            >
                              <div className="flex justify-between">
                                <a
                                  target="_blank"
                                  href={element.viewUrl}
                                  className="text-start mb-2"
                                >
                                  <i className="fa-light fa-arrow-up-from-bracket me-2"></i>{" "}
                                  {element.fileName}
                                </a>
                                <div>
                                  <i className="fa-sharp fa-solid fa-circle-check onedose-color me-2"></i>
                                  <a href="#">
                                    <i className="fa-thin fa-trash-can"></i>
                                  </a>
                                </div>
                              </div>
                              <div className="flex w-full h-1.5 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700">
                                <div
                                  className="flex flex-col justify-center overflow-hidden bg-blue-500"
                                  role="progressbar"
                                  style={{
                                    width: `100%`,
                                    backgroundColor: `#09C35C`,
                                  }}
                                  aria-valuenow="25"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div
                              id={`hs-vertically-centered-modal${index}`}
                              className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[100] overflow-x-auto overflow-y-auto"
                            >
                              <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
                                <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                                  <div className="p-4 overflow-y-auto">
                                    <div className="ratio ratio-16x9">
                                      <iframe
                                        src={element.viewUrl}
                                        title="YouTube video"
                                        allowFullScreen
                                      ></iframe>
                                    </div>
                                  </div>
                                  <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                    <button
                                      type="button"
                                      className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                                      data-hs-overlay={`#hs-vertically-centered-modal${index}`}
                                    >
                                      Kapat
                                    </button>
                                    {/* <a className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800" href="#">
                                      Save changes
                                    </a> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              ) : null}
            </div>
            <div
              id="tabs-with-badges-4"
              className="hidden"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-4"
            >
              {props.getApplication.done ? (
                <div>
                  {props.getApplication.getApplication.results.length === 0 ? (
                    <div>
                      <h4 className="text-red-400 text-2xl mt-5">
                        İnceleme Süresi Devam Ediyor
                      </h4>
                      <p className="text-gray-500 mt-3">
                        Raporunuz henüz oluşturulmadı, ancak rapor
                        oluşturulduğunda <br /> sonuçlarım bölümünde raporunuza
                        erişebilirsiniz.
                      </p>
                    </div>
                  ) : (
                    <div>
                      <h4 className="mt-4">Başvuru Raporu (Doktor Görüşü)</h4>
                      <iframe
                        width="100%"
                        height="900"
                        src={`data:application/pdf;base64,${props.getApplication.getApplication.results[0].result}`}
                      ></iframe>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-5 ps-5 pe-5 md:ml-64 text-start">
          <div className="relative">
            <div
              style={{ backgroundColor: `#09c35d7c` }}
              className="bg-blue-50 border border-blue-200 rounded-md p-4"
            >
              <div className="flex">
                <div className="flex-shrink-0">
                  <i className="fa-light fa-file"></i>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm text-blue-800 font-medium">
                    Detay yükleniyor
                  </h3>
                  <div className="text-sm text-blue-700 mt-2">
                    <span className="font-semibold">Lütfen bekleyin!</span>{" "}
                    Başvurunuzun detayı yükleniyor.
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div
                className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
                role="status"
                aria-label="loading"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ApplicationDetail);
